/*eslint-disable*/
import React, { useEffect } from 'react'
import AOS from 'aos'
import Navbar from '../components/header/navbar'
const NotFound = () => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])
  return (
    <div className="mx-auto max-w-7xl mb-8 sm:mb-12 md:mb-16">
      <Navbar />
      <div className='w-full flex items-center flex-wrap pb-8 sm:pb-10 md:pb-12'>
        <div className='w-full md:w-1/2 px-4 md:pl-8 lg:pl-16'>
          <div className='text-left sm:pl-4 lg:pl-10'>
            <h1
              className='text-3xl sm:text-4xl md:text-8xl lg:leading-tight tracking-tight font-bold text-gray-900'
              data-aos='flip-up'
              data-aos-duration='1000'
            >
              404 <br className='hidden md:block' />
            </h1>
            <h2 className='text-2xl sm:text-3xl md:text-6xl'>
              oops! <br /> Page Not Found
            </h2>

            <p className='my-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
              This Page does not exist or was removed
              <br className='hidden md:block' /> We suggest you go back to Home
            </p>
          </div>
        </div>

        <div className='w-full md:w-1/2'>
          <div className=''>
            <img
              className='w-full sm:w-5/6 mx-auto object-cover'
              src='/assets/images/login/notfound.png'
              alt=''
              data-aos='fade-up'
              data-aos-duration='1000'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound
